import React from "react";
import { DTConfigInGalleryContext } from "../../../../../server/public/sites/client/gallery/scripts/DTConfigInGalleryContext.js";
import { useContentDt } from "../../../../../server/public/sites/client/gallery/scripts/useContentDt.js";
import PlainEditor from "../editor/plainEditor.js";
export default function RichTextComponent(props) {
    const text = useContentDt(props.component.text, DTConfigInGalleryContext);
    return (React.createElement("div", { id: props.component.id, className: props.isOutlined ? "flow-component-outlined" : "" },
        React.createElement(PlainEditor, { editable: false, example: text, update: text, onChange: () => { }, label: "" })));
}
